import React from "react";
import {Helmet} from "react-helmet-async";

const ProjectsPage = () => (
    <>
        <Helmet>
            <title>Projekt</title>
        </Helmet>
        <div>
            <h1>Projekt</h1>
            <p>Innehåll kommer visas här</p>
        </div>
    </>
);

export default ProjectsPage;
